import { types } from "../type";

const initialState = {
  locations: null,
  locationError: "",
  locationStatus: 0,
  locationResponse: "",
  locationLoading: false,
  numberOfActiveUsers: [],
  locationCreateLoading: false
};

const locationReducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case types.LocationTypes.LOCATION_SET_LOADING:
      return {
        ...state,
        locationLoading: payload
      };
    case types.LocationTypes.LOCATION_SET_CREATE_LOADING:
      return {
        ...state,
        locationCreateLoading: payload
      };
    case types.LocationTypes.LOCATION_CLEAR_ERRORS:
      return {
        ...state,
        locationError: ""
      };
    case types.LocationTypes.LOCATION_GET_ERRORS:
      return {
        ...state,
        locationLoading: false,
        locationCreateLoading: false,
        locationError: payload.data.message,
        locationStatus: payload.status
      };
    case types.LocationTypes.LOCATION_CLEAR_RESULT:
      return {
        ...state,
        locationResponse: ""
      };
    case types.LocationTypes.GET_LOCATIONS:
      return {
        ...state,
        locationLoading: false,
        locations: payload.locations,
        numberOfActiveUsers: payload.numberOfActiveUsers
      };
    case types.LocationTypes.CREATE_LOCATION:
      return {
        ...state,
        locationLoading: false,
        locationResponse: payload
      };
    case types.LocationTypes.LOCATION_UNMOUNT:
      return {
        ...state,
        locations: null
      };
    default:
      return state;
  }
};

export default locationReducer;
